import AixueHeader from '@/components/AixueHeader/index';
import styles from './index.module.scss';

export default function Screen1() {
  return (
    <section className={styles['screen1-cover']}>
      {/* 头部导航 */}
      <div className={styles['screen1-header']}>
        <AixueHeader title="爱学" />
      </div>

      <div className={styles['screen1-wrap']}>
        <div className={styles['screen1-content']}>
          <div className={styles['screen1-title']}></div>
          <div className={styles['screen1-desc']}>
            爱学AI一对一导师是新一代AI互动学习产品。它依托于自研的爱学大模型，利用真人级数字人导师，结合多模态感知能力，构建全年龄、全学科、全方位的智能学习场景，为学习者提供终身学习的个性化成长陪伴。
          </div>
        </div>
      </div>
    </section>
  );
}
